module.exports = __webpack_public_path__ + "img/withoutbanner.405f08e7.png";